import { StatusMap, BtnStatusMap } from './types'
import { LangEum } from '@/constant'

const zhTWSnapUpStatus = {
  [StatusMap.over]: '搶完了',
  [StatusMap.end]: '已結束',
  [StatusMap.ing]: '搶購中',
  [StatusMap.aboutOf]: '即將開始',
}

const jaSnapUpStatus = {
  [StatusMap.over]: '売切れ',
  [StatusMap.end]: '已結束',
  [StatusMap.ing]: '現在セール中',
  [StatusMap.aboutOf]: 'にセール開始',
}

const enSnapUpStatus = {
  [StatusMap.over]: 'SOLD OUT',
  [StatusMap.end]: 'Ended',
  [StatusMap.ing]: 'Ongoing',
  [StatusMap.aboutOf]: 'Upcoming',
}

const enLang = {
  start: 'Starts in',
  end: 'Ends in',
  remindOpen: 'Reminder is set. You’ll be notified 5 minutes before the event starts.',
  remindClose: 'Reminder is canceled',
  sysOpenMsg: 'Please enable your push notifications to receive event reminders and updates.',
  sysOpenOkText: 'Enable',
  sysOpenCancelText: 'Cancel',
  activeOverMsg: 'This event has ended',
  appVersionUpdateMsg:
    'Please update your app to the latest version to participate in the Flash Sale event.',
  appVersionUpdateOkText: 'Ok',
  appVersionUpdateCancelText: 'Cancel',
  errorMsg: 'Please exit and re-enter this page for Flash Sale.',
  getCurSaleOut(nextTime?: string) {
    if (!nextTime) {
      // TODO
      return 'This event is sold out.'
    }
    return `This event is sold out. The next one starts at ${nextTime}`
  },
  getCurActiveOver(nextTime?: string) {
    if (!nextTime) {
      // TODO
      return 'This event has ended.'
    }
    return `This event has ended. The next one starts at ${nextTime}`
  },
  getRemainingNumber(num: number) {
    return `${num} Left`
  },
  getTotalNumber(num: number) {
    return `Total: ${num}`
  },
  btnStatus: {
    [BtnStatusMap.saleOver]: 'SOLD OUT',
    [BtnStatusMap.goBuy]: 'BUY NOW',
    [BtnStatusMap.isSetting]: 'Alert set',
    [BtnStatusMap.remind]: 'Alert me',
  },
  snapUpStatus: enSnapUpStatus,
}

const zhTWLang = {
  start: '距開始',
  end: '距結束',
  remindOpen: '設置成功。將在開售前5分鐘提醒您',
  sysOpenMsg: '系統提醒功能未開放，無法成功提醒到您，去開啟吧',
  sysOpenOkText: '開啟推送',
  sysOpenCancelText: '取消',
  remindClose: '提醒已取消',
  activeOverMsg: '活動已結束',
  appVersionUpdateMsg: '參與秒殺活動需要更新最新版本的APP喲',
  appVersionUpdateOkText: '知道了',
  appVersionUpdateCancelText: '取消',
  errorMsg: '請重新進入該頁面進行搶購',
  getCurSaleOut(nextTime?: string) {
    if (!nextTime) {
      // TODO
      return '本场已售罄'
    }
    return `本场已售罄，下场开始时间 ${nextTime}`
  },
  getCurActiveOver(nextTime?: string) {
    if (!nextTime) {
      // TODO
      return '活動已結束'
    }
    return `本場已結束，下一場開始時間 ${nextTime}`
  },
  getRemainingNumber(num: number) {
    return `僅剩${num}件`
  },
  getTotalNumber(num: number) {
    return `共 ${num} 件`
  },
  btnStatus: {
    [BtnStatusMap.saleOver]: '搶完了',
    [BtnStatusMap.goBuy]: '去搶購',
    [BtnStatusMap.isSetting]: '已設置',
    [BtnStatusMap.remind]: '提醒我',
  },
  snapUpStatus: zhTWSnapUpStatus,
}
const zhSGLang = {
  start: '距开始',
  end: '距結束',
  remindOpen: '设置成功。将在开售前5分钟提醒您',
  sysOpenMsg: '系統提醒功能未开放，无法成功提醒到您，去开启吧',
  sysOpenOkText: '开放推送',
  sysOpenCancelText: '取消',
  remindClose: '提醒已取消',
  activeOverMsg: '活动已结束',
  appVersionUpdateMsg: '参与秒杀活动需要更新最新版本的APP呦',
  appVersionUpdateOkText: '知道了',
  appVersionUpdateCancelText: '取消',
  errorMsg: '请重新进入该页面进行抢购',
  getCurSaleOut(nextTime?: string) {
    if (!nextTime) {
      // TODO
      return '本场已售罄'
    }
    return `本场已售罄，下场开始时间 ${nextTime}`
  },
  getCurActiveOver(nextTime?: string) {
    if (!nextTime) {
      // TODO
      return '活动已结束'
    }
    return `本场已结束，下一场开始时间 ${nextTime}`
  },
  getRemainingNumber(num: number) {
    return `仅剩${num}件`
  },
  getTotalNumber(num: number) {
    return `共 ${num} 件`
  },
  btnStatus: {
    [BtnStatusMap.saleOver]: '抢完了',
    [BtnStatusMap.goBuy]: '去抢购',
    [BtnStatusMap.isSetting]: '已设置',
    [BtnStatusMap.remind]: '提醒我',
  },
  snapUpStatus: zhTWSnapUpStatus,
}

export type LangType = typeof enLang

export const langMap = {
  [LangEum.en]: enLang,
  [LangEum['zh-TW']]: zhTWLang,
  [LangEum['zh-TW2']]: zhTWLang,
  [LangEum['zh-MO']]: zhTWLang,
  [LangEum['zh']]: zhSGLang,
  [LangEum['zh-SG']]: zhSGLang,
  [LangEum['zh-MY']]: zhSGLang,
  [LangEum.ja]: enLang,
  [LangEum.zh]: enLang,
}

export default langMap
